export default __webpack_public_path__ + "static/media/theaterModeIcon.8a3cd36b.svg";